var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-home"},[_c('BtnWhatsapp',{staticClass:"my-home__btn"}),(_vm.$locale)?_c('div',[_c('Header'),_c('router-view'),_c('Footer')],1):_vm._e(),_c('Preload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$loaded),expression:"!$loaded"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }